export function getWindow(): typeof globalThis & Record<any, any> {
  return globalThis
}
